export const COLORS = {
  text: "#1f1f1f",
  background: "#c4d1a3",
  primary: "#1f1f1f",
  secondary: "#8b966e",
  accent: "#ffd900",
  light: "#ffffff",
};
